import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { ro } from "date-fns/locale/ro";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("ro", ro);

function pad(n) {
  return String(n).padStart(2, "0");
}

function NewEvent({ onSuccess }) {
  const [isOpen, setIsOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [name, setName] = useState("");
  const [dateTime, setDateTime] = useState(null);
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  const resetForm = () => {
    setName("");
    setDateTime(null);
    setDescription("");
    setImage(null);
    setPreviewUrl(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", name);
    formData.append(
      "date",
      dateTime ? `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1)}-${pad(dateTime.getDate())}` : ""
    );
    formData.append(
      "time",
      dateTime ? `${pad(dateTime.getHours())}:${pad(dateTime.getMinutes())}` : ""
    );
    formData.append("description", description);
    if (image) {
      formData.append("image", image);
    }

    try {
      const token = localStorage.getItem("access_token");

      const response = await fetch(
        "https://awaretherapycenter.ro/events-back/create/",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccess("Eveniment adăugat cu succes!");
        onSuccess?.();
        setError("");
        resetForm();
        setIsOpen(false);
      } else {
        setError(data.error || "Eroare la adăugare.");
        setSuccess("");
      }
    } catch (err) {
      console.error("Eroare rețea:", err);
      setError("Eroare de rețea.");
    }
  };

  return (
    <div>
      <button
        className="evp-add-btn"
        onClick={() => setIsOpen(true)}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
        Adaugă eveniment
      </button>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="evp-overlay">
        <div className="evp-overlay-bg" aria-hidden="true" />
        <div className="evp-dialog-scroll">
          <Description className="sr-only" />
          <form onSubmit={handleSubmit}>
            <DialogPanel className="evp-dialog-box">
              <button type="button" className="evp-close-x" onClick={() => setIsOpen(false)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </button>
              <DialogTitle as="h3">Adaugă eveniment</DialogTitle>

              <div className="evp-field">
                <label>Imagine eveniment</label>
                <div className="evp-upload">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setImage(file);
                        setPreviewUrl(URL.createObjectURL(file));
                      }
                    }}
                  />
                  <div className="evp-upload-thumb">
                    {previewUrl ? (
                      <img src={previewUrl} alt="Preview" />
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                    )}
                  </div>
                  <span className="evp-upload-text">Alege o imagine reprezentativă pentru eveniment</span>
                </div>
              </div>

              <div className="evp-field">
                <label>Nume eveniment</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="evp-field">
                <label>Dată și oră</label>
                <DatePicker
                  selected={dateTime}
                  onChange={(d) => setDateTime(d)}
                  showTimeSelect
                  timeIntervals={15}
                  timeCaption="Oră"
                  dateFormat="d MMMM yyyy, HH:mm"
                  locale="ro"
                  placeholderText="Selectează data și ora"
                  minDate={new Date()}
                  className="evp-dt-input"
                  calendarClassName="evp-dt-cal"
                  popperClassName="evp-dt-popper"
                  autoComplete="off"
                  required
                />
              </div>

              <div className="evp-field">
                <label>Descriere</label>
                <textarea
                  rows={6}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                ></textarea>
              </div>

              {error && <p className="evp-msg error">{error}</p>}
              {success && <p className="evp-msg success">{success}</p>}

              <div className="evp-dialog-actions">
                <button type="submit" className="evp-btn-primary"><span>Adaugă</span></button>
                <button type="button" className="evp-btn-secondary" onClick={() => setIsOpen(false)}>Anulează</button>
              </div>
            </DialogPanel>
          </form>
        </div>
      </Dialog>
    </div>
  );
}

export default NewEvent;
